import IntroCarousel from "../IntroCarousel";
import "./../styles/home.css";
import Ad from "../Ad";
import GameHomepage from "../GameHomepage";
import Photos from "../Photos";
import AboutHome from "../AboutHome";
import ActivitiesHome from "../ActivitiesHome";
import ArticlesGrid from "../ArticlesGrid";
import ArticleSlider from "../ArticleSlider";

const Home = () => {


    return (
        <div>
            <IntroCarousel />


            <ArticleSlider />
            <div id='entertainment'>
                <div style={{ display: 'flex', gap: '1em', alignItems: 'center' }}>
                    <img id='entertainment-icon' src={process.env.PUBLIC_URL + 'images/entertainment-icon-gold.png'} alt='entertainment icon'></img>
                    <h2 id='entertainment-h'>ENTERTAINMENT</h2>
                </div>

                <div id='entertainment-line'></div>


                <p>Step into our Entertainment section and dive into a world of fun! Challenge yourself with our vocalist-inspired Tic-Tac-Toe, put your show choir knowledge to the test with our exciting crossword puzzles and trivia games, or unleash your creativity with our interactive coloring book. Ready for more? Embark on a thrilling digital scavenger hunt, and don’t miss the chance to showcase your own event photos in our vibrant photo gallery. There's something for everyone—come join the fun! </p>

            </div>


            <GameHomepage />


            <ActivitiesHome />

            <Photos />

            <AboutHome />

            {/* <div id="home-bgline" style={{ backgroundImage: `url('images/home-bg-line.png')` }}></div> */}

            <Ad />
        </div>
    )
}

export default Home
